// Reference-PLZ search box: wires an <input> + <ul> suggestion list to logic.searchPlz.
import { formatHit, searchPlz, type SearchHit } from "../logic";
import type { PlzIndex } from "../registry";

export interface SearchBoxOptions {
  input: HTMLInputElement;
  list: HTMLUListElement;
  onSelect: (plz: string) => void;
}

export function initSearchBox(index: PlzIndex, opts: SearchBoxOptions): void {
  let hits: SearchHit[] = [];

  function show(next: SearchHit[]): void {
    hits = next;
    opts.list.innerHTML = "";
    for (const hit of hits) {
      const li = document.createElement("li");
      li.textContent = formatHit(hit);
      li.setAttribute("role", "option");
      li.tabIndex = -1;
      // mousedown (not click) fires before the input's blur, so the selection survives.
      li.addEventListener("mousedown", (e) => {
        e.preventDefault();
        select(hit.plz);
      });
      opts.list.appendChild(li);
    }
    opts.list.hidden = hits.length === 0;
  }

  function select(plz: string): void {
    opts.onSelect(plz);
    opts.input.value = "";
    show([]);
    opts.input.blur();
  }

  opts.input.addEventListener("input", () => show(searchPlz(index, opts.input.value)));
  opts.input.addEventListener("keydown", (e) => {
    if (e.key === "Enter" && hits.length > 0) {
      e.preventDefault();
      select(hits[0].plz);
    } else if (e.key === "Escape") {
      show([]);
      opts.input.blur();
    }
  });
  opts.input.addEventListener("blur", () => {
    // let a pending mousedown-on-suggestion handler run first
    setTimeout(() => show([]), 150);
  });
}
